import * as types from '../actiontypes';
import {
	gaScopesRoutes,
	promiseAreas,
	serviceURL,
	userType,
	ValidationGroup,
	engagementAccessTypeEnum
} from './../../util/uiconstants';
import Env from '../../util/env';

export function getEngagement(url) {
	return {
		type: types.GET_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementMetaData(url) {
	return {
		type: types.LOAD_ENGAGEMENTMETADATA,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementProfileData(url) {
	return {
		type: types.GET_ENGAGEMENT_PROFILE_DATA,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementUsersWithRoles(url) {
	return {
		type: types.GET_ENGAGEMENT_USERS_WITHROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.USERROLE_SELECTION_AREA
			}
		}
	};
}

export function selectEngagementUserRoleItem(payload) {
	return {
		type: types.SELECT_ENGAGEMENT_USERROLE_ITEM,
		payload
	};
}

export function updateEngagement(url, data) {
	return {
		type: types.UPDATE_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'PATCH',
				data: data
			}
		}
	};
}

export function unlinkGroupEngagement(engagementId) {
	const url = `${Env.getBaseURL(serviceURL, engagementId)}${gaScopesRoutes.groupLinks}`;
	return {
		type: types.UNLINK_ENGAGEMENT_GROUP,
		meta: {
			api: {
				url: url,
				method: 'DELETE'
			}
		},
		engagementId
	};
}

export function getIndependenceConfirmationMembers(engagementId) {
	const url = getIndependenceUsersUrl(engagementId);

	return {
		type: types.GET_ENGAGMENT_USER_INDEPENDENCE,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function cleanIndependenceConfirmationMembers() {
	return {
		type: types.CLEAN_ENGAGMENT_USER_INDEPENDENCE
	};
}

//#region Common
function getIndependenceUsersUrl(engagementId) {
	return `${Env.getBaseURL(serviceURL, engagementId)}Users?UserType=${
		userType.IndependenceConfirmations
	}&FilterEngagementAccessType=Default&FilterEngagementAccessType=
		IndependenceOnly`;
}
//#endregion

export function getIndependenceValidations(engagementId) {
	return {
		type: types.GET_INDEPENDENCE_VALIDATIONS,
		meta: {
			api: {
				url: getIndependenceValidationsUrl(engagementId),
				method: 'GET'
			}
		}
	};
}

function getIndependenceValidationsUrl(engagementId) {
	return `${Env.getBaseURL(serviceURL, engagementId)}Validations?ValidationGroups=${
		ValidationGroup.IndependenceValidations
	}&includeDetail=true`;
}

export function GetIPFilteringStatus(engagementId) {
	let urlIPFiltersStatus = `${Env.getBaseURL(serviceURL, engagementId)}IPFilterStatus`;
	return {
		type: types.GET_ENGAGEMENT_IPFILTERSTATUS,
		meta: {
			api: {
				url: urlIPFiltersStatus,
				method: 'GET'
			}
		}
	};
}

export function getAllEngagements(url, query) {
	return {
		type: types.GET_ALL_ENGAGEMENTS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		},
		payload: query
	};
}
